<template>
  <div>
    <show-credential-terminals-tef ref="ShowCredentialTerminalsTef" />
  </div>
</template>
<script>
export default {
  components: {
    ShowCredentialTerminalsTef: () => import('./ShowCredentialTerminalsTef.vue'),
  },
}
</script>
